import cache from '~/plugins/cache'

const TokenKey = 'Disk-Token'

export function getToken(app) {
  return cache.cookie.get(app,TokenKey)
}

export function setToken(app,token) {
  return cache.cookie.set(app,TokenKey, token)
}

export function removeToken(app) {
  return cache.cookie.remove(app,TokenKey)
}
